<template>
  <!-- 广告为纵向排列 -->
  <van-popup v-model="show" class="avtPopup" @close="closeMask">
    <div class="avt_box">
      <div class="top">
        <div v-for="item in list" :key="item.id" :class="`title_item ${active === item.id ? 'active' : ''}`"
          @click="change(item)">
          <img v-if="item.type === 0" class="icon email" src="../assets/images/common/email.png">
          <div v-else class="icon notice" />
          <div class="title">
            {{ item.title || 'title' }}
          </div>
        </div>
      </div>
      <div class="bottom" :style="{ height: activeObj.type === 0 ? 'auto' : 'auto' }">
        <!-- <van-icon
            class="left arrow"
            name="arrow-left"
            @click="handleArrow('left')"
          />
          <van-icon
            class="right arrow"
            name="arrow"
            @click="handleArrow('right')"
          /> -->
        <template v-if="activeObj.type === 0">
          <div v-html="activeObj.content" />
        </template>
        <template v-if="activeObj.type === 1">
          <img :src="activeObj.image" alt="" class="pic">
        </template>
      </div>
    </div>
    <div class="checkBox">
      <van-checkbox v-model="checked" shape="square" class="check" :icon-size="14">
        {{ $t("今天不再显示") }}
      </van-checkbox>
    </div>
    <div class="close_box" @click="closeMask">
      <img src="../assets/images/common/close.png" class="close">
    </div>
  </van-popup>
</template>
<script>
import Fetch from "../utils/fetch";
const storageName = 'HOME_SHOW_AVT'
export default {
  props: {
    avtImg: Array
  },
  data() {
    return {
      show: false,
      checked: false,
      active: 0,
      activeObj: {},
      list: []
    }
  },
  watch: {
    show(newval) {
      if (!newval) {
        this.setLocalStorage()
        this.$emit("showPopup", true);
      }
    },
    avtImg: {
      deep: true,
      handler(n, o) {
        this.list = n;
        const firstObj = this.list[0]
        this.active = firstObj.id
        this.activeObj = firstObj
        const data = localStorage.getItem(storageName);
        let signData = localStorage.getItem("signPop");
        let showSign = localStorage.getItem("showSign");
        if ((!data || data && !JSON.parse(data).value || new Date(JSON.parse(data).date).getDate() !== new Date().getDate())) {
          this.show = true
        } else {
          if ((!signData || signData && !JSON.parse(signData).value || new Date(JSON.parse(signData).date).getDate() !== new Date().getDate())) {
            if (showSign == "1") {
              this.$parent.show_tc3 = true;
            } else {
              this.$parent.show_tc3 = false;
            }
          } else {
            this.$parent.show_tc3 = false
          }
        }


      }
    }
  },
  mounted() {
    this.initAvt()
  },
  methods: {
    getList() {
    },
    initAvt() {
      const data = localStorage.getItem(storageName)
      if ((!data || data && !JSON.parse(data).value || new Date(JSON.parse(data).date).getDate() !== new Date().getDate())) {
        this.getList()
      }
      if (!this.show) {
        this.$emit("showPopup", true);
      }
    },
    change(item) {
      this.active = item.id
      this.activeObj = item
    },
    handleArrow(type) {
      const length = this.list.length
      if (type === 'left' && this.active > 0) {
        this.active -= 1
      } else if (type === 'left' && this.active === 0) {
        this.active = length - 1
      } else if (type === 'right' && this.active < length - 1) {
        this.active += 1
      } else if (type === 'right' && this.active === length - 1) {
        this.active = 0
      }
    },
    setLocalStorage() {
      const data = {
        value: this.checked,
        date: new Date().getTime()
      }
      localStorage.setItem(storageName, JSON.stringify(data))
    },
    closeMask() {
      this.$emit('close')
      this.show = false;
      let signData = localStorage.getItem("signPop");
      let showSign = localStorage.getItem("showSign");
      if (showSign == "1") {
        if ((!signData || signData && !JSON.parse(signData).value || new Date(JSON.parse(signData).date).getDate() !== new Date().getDate())) {
          this.$parent.show_tc3 = true
        } else {
          this.$parent.show_tc3 = false
        }
      } else {
        this.$parent.show_tc3 = false
      }

    }
  }
}
</script>
<style scoped lang="less">
@import "../assets/css/variables.less";

.avtPopup {
  width: 90%;
  max-width: 375px;
  background-color: transparent;

  .avt_box {
    // display: flex;
    border-radius: 12px;
    border: 1px solid @bodercolor2;
    background-color: @primary-color;
    overflow: hidden;
  }
}

.top {
  display: flex;
  // padding: 4px;
  overflow: hidden;
  width: 100%;
  border-bottom: 1px solid @bodercolor2;
}

.title_item {
  width: 100%;
  margin-right: 1%;
  max-width: 120px;
  display: flex;
  align-items: center;
  color: @third-color;
  padding: 8px 4px;
  box-sizing: border-box;

  &.active {
    color: @textcolor1;
    background-color: @activityColor;

    .icon {
      mask-size: contain !important;

      &.notice {
        background-color: @textcolor1;
      }

      &.email {
        opacity: 1;
      }
    }
  }

  .title {
    flex: 1;
    font-size: 12px;
    overflow: hidden;
    /*必须结合的属性,当内容溢出元素框时发生的事情*/
    text-overflow: ellipsis;
    /*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
    display: -webkit-box;
    /*必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
    -webkit-line-clamp: 2;
    /*用来限制在一个块元素显示的文本的行数。*/
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .icon {
    color: @third-color;
    margin-right: 6px;
    width: 14px;
    height: 14px;

    &.notice {
      background-color: @third-color;
      mask: url(../assets/images/index/notice.gif) center center no-repeat;
      mask-size: cover;
    }

    &.email {
      opacity: 0.8;
    }
  }
}

.bottom {
  flex: 1;
  position: relative;
  height: 220px;
  overflow-y: auto;
  // padding: 0 8px;

  /deep/ img {
    width: 100% !important;
  }

  .arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
    color: #fff;

    &.right {
      right: 2%;
    }

    &.left {
      left: 2%;
    }
  }
}

.pic {
  width: 100%;
  border-radius: 0 0 12px 12px;
}

.checkBox {
  padding: 10px;
  display: flex;
  justify-content: center;

  .check {
    padding: 6px 10px;
    background-color: rgba(0, 0, 0, 0.2);

    :deep(.van-checkbox__label) {
      color: #fff;
    }

    :deep(.van-icon-success) {
      background-color: transparent !important;
    }

    :deep(.van-checkbox__icon--checked) {
      background-color: #04BE02 !important;
    }
  }
}

.close_box {
  .close {
    width: 20px;
    height: 20px;
    margin: 10px auto;
    display: block;
  }
}
</style>